import { createSelector } from '@reduxjs/toolkit';
import { TECH_SPECIFICATIONS_NAME } from '@yme/common/constants';
import { getLowestPriceAttribute } from '@yme/pdp-components/ProductCard/helpers';
import { getState } from '@yme/selectors/common';
import { ABB_PRODUCT_NAME_LOCALIZED_KEY } from '@yme/selectors/constants';
import { STUDIO_IMAGE } from '@yme/utils/constants';
const getComparisonPage = createSelector(getState, (state) => state.comparisonProducts);
export const getProducts = createSelector(getComparisonPage, (data) => data.products.map((product) => {
    const { id, variants, key, name, categories, slug } = product;
    const masterData = variants.find((variant) => variant.master);
    const studioImage = masterData?.images.find((image) => image.url.toLowerCase().includes(STUDIO_IMAGE));
    const titleAttribute = masterData?.attributes.find((attribute) => attribute.name === ABB_PRODUCT_NAME_LOCALIZED_KEY);
    const specifications = masterData?.attributes.find((attribute) => attribute.name === TECH_SPECIFICATIONS_NAME);
    const variantsPrices = variants.flatMap((variant) => variant.prices);
    return {
        ...product,
        title: titleAttribute?.value ?? name,
        id,
        key,
        sku: masterData?.sku ?? slug,
        image: studioImage,
        price: getLowestPriceAttribute(variantsPrices),
        specifications,
        categories,
        slug,
    };
}));
export const getComparisonPageIsLoaded = createSelector(getComparisonPage, (data) => data.isLoaded);
export const getComparisonProductsKeys = createSelector(getProducts, (products) => products.map((product) => product.key));
